import TableCell from "@mui/material/TableCell";
import { GenericSelect } from "@asez/component-library";

const SelectCell = ({ value, onChangeHandler, options, classes, sx }) => {
  return (
    <TableCell
      align="center"
      sx={{ ...sx, borderRight: 1, borderColor: "var(--color-table-header)" }}
    >
      <div className={`mx-auto ${classes}`}>
        <GenericSelect
          className={`mx-auto ${classes}`}
          value={value}
          onChange={onChangeHandler}
          options={options}
        />
      </div>
    </TableCell>
  );
};

export default SelectCell;
